import { format, parseISO } from 'date-fns';
import { enGB, el } from 'date-fns/locale';
import { locale } from 'moment';

export function FormatDate(value: string | Date): string {
  if (value === null) return '-';

  if (value instanceof Date) return format(value, 'dd/MM/yyyy');
  else return format(parseISO(value), 'dd/MM/yyyy');
}

export function FormatDateTime(value: string | Date, formatString = 'dd/MM/yyyy HH:mm:ss'): string {
  console.log('FormatDateTime args');
  if (!value) return '-';
  const formatOptions = {
    locale: el,
  };
  try {
    if (value instanceof Date) return format(value, formatString, formatOptions);
    else return format(parseISO(value), formatString, formatOptions);
  } catch (error) {
    return value ? value.toString() : '-';
  }
}

export function FormatTime(value: string | Date | number): string {
  if (value instanceof Date) return format(value, 'HH:mm:ss');
  else if (typeof value === 'number') return format(new Date(value), 'HH:mm:ss');
  else if (typeof value === 'string') return format(parseISO(value), 'HH:mm:ss');
  else return '-';
}

/**
 * Υπολογίζε την διαφορά σε μέρες μεταξύ 2 ημερομηνιών
 * πρέπει D1 > D0 για θετικό πρόσημο
 * @param dateStr1
 * @param dateStr2
 * @returns INT
 */
export function daysDifference(d0: string | number | Date, d1: string | number | Date): number {
  const diff = new Date(+d1).setHours(12) - new Date(+d0).setHours(12);
  return Math.round(diff / 8.64e7);
}

/**
 * Υπολογίζε την διαφορά σε μέρες μεταξύ 2 ημερομηνιών
 * πρέπει D1 > D0 για θετικό πρόσημο
 * @param dateStr1
 * @param dateStr2
 * @returns
 */
export function DateDiffInDays(dateStr1, dateStr2) {
  const date1 = new Date(dateStr1);
  const date2 = new Date(dateStr2);
  return daysDifference(date1, date2);
}

/**
 *
 * @param dateStr2 Υπολογίζει για μία περασμένη ημερομηνία πόσες μέρες ήταν πρίν απο το σήμερα
 * @returns
 */
export function daysBeforeToday(dateStr2) {
  const dateStr1 = new Date();
  return daysDifference(dateStr2, dateStr1) + 1;
}

export function startOfDay(dt: Date | string): Date | string {
  const startOfDay = typeof dt == 'string' ? new Date(dt) : dt;
  startOfDay.setHours(0, 0, 0, 0);
  return typeof dt == 'string' ? startOfDay.toISOString() : startOfDay;
}

export function endOfDay(dt: Date | string): Date | string {
  const endOfDay = typeof dt == 'string' ? new Date(dt) : dt;
  endOfDay.setHours(23, 59, 59, 999);
  return typeof dt == 'string' ? endOfDay.toISOString() : endOfDay;
}

export function startOfMonth(value: Date | string): Date | string {
  const dt = typeof value == 'string' ? new Date(value) : value;
  const ret = startOfDay(new Date(dt.getFullYear(), dt.getMonth(), 1));
  return typeof value == 'string' ? (ret as Date).toISOString() : ret;
}

export function endOfMonth(value: Date | string): Date | string {
  const dt = typeof value == 'string' ? new Date(value) : value;
  const ret = endOfDay(new Date(dt.getFullYear(), dt.getMonth() + 1, 0));
  return typeof value == 'string' ? (ret as Date).toISOString() : ret;
}

export function formatDate(value: string): string {
  return format(parseISO(value), 'dd/MM/yyyy');
}

export function formatDateTime(value: string): string {
  try {
    if (!value) return '-';
    return format(parseISO(value), 'dd/MM/yyyy HH:mm');
  } catch (error) {
    console.error('formatDateTime', typeof value, error);
    return value.toString();
  }
}
